import { render, staticRenderFns } from "./CPDealingInstructionsModal.vue?vue&type=template&id=6c61ee9e&scoped=true&"
import script from "./CPDealingInstructionsModal.vue?vue&type=script&lang=ts&"
export * from "./CPDealingInstructionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./CPDealingInstructionsModal.vue?vue&type=style&index=0&id=6c61ee9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c61ee9e",
  null
  
)

export default component.exports